var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.fetched || _vm.filteredListings)?_c('google-map',{attrs:{"markers-data":_vm.markersData,"map-options":_vm.mapOptions},on:{"search-nearby":_vm.nearbyListings}}):_c('div',{staticClass:"no-map"},[_c('img',{staticClass:"w-full pa-16",attrs:{"src":_vm.grayMap,"alt":"gray map"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }